export default __webpack_public_path__ + "static/PromptIconOne-bec8c262c95756db5f4d7e64ba77bc01.png";